import { PUBLISHED_CONTROLLERS } from '~/controllers/loader/published_registry'
import { createCoachResolver as createControllerResolver } from '~/controllers/loader/coach_resolver'
import { initializeControllerLoader } from '~/controllers/loader/runtime'
import { observeTextDecorations } from '~/controllers/loader/text_decoration_activation'

initializeControllerLoader(
  createControllerResolver(PUBLISHED_CONTROLLERS, () =>
    import('~/controllers/loader/lazy_loader')
  )
)
observeTextDecorations(
  document.documentElement,
  (name) => name in PUBLISHED_CONTROLLERS
)
